var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collect-detail" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card rule",
          staticStyle: { "margin-bottom": "10px" },
          attrs: { shadow: "never" },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", { staticClass: "title" }, [_vm._v("基本信息")]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("卡类型："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.card_type_name)),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("客户ID："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.customer_id)),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("销售负责人："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.sale_user_name)),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("所属部门： "),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.organize_name)),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("申请时间："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.created_time)),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("领卡状态："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.status_cn)),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("预计领卡日期："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(
                  _vm._s(_vm.info.expected_card_date) +
                    " " +
                    _vm._s(_vm.info.expected_card_time)
                ),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("领卡需求数："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.number)),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("领卡经办人："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.perator_user_name)),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("领卡日期："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(
                  _vm._s(_vm.info.card_date) + " " + _vm._s(_vm.info.card_time)
                ),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("领卡天数："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(" " + _vm._s(_vm.info.receive_day) + " "),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("起始序列号："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.begin_code)),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("结束序列号："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.end_code)),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("异常处理状态："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(" " + _vm._s(_vm.info.exception_status_cn) + " "),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("备注："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.note)),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("物料类型："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.material_type_cn)),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }),
          ]),
          _c("el-divider"),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("卡数量："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(" " + _vm._s(_vm.info.number) + " "),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("待售："),
              ]),
              _c(
                "span",
                { staticClass: "info__con", staticStyle: { color: "#ff0000" } },
                [_vm._v(_vm._s(_vm.info.not_sale_number))]
              ),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("未激活："),
              ]),
              _c(
                "span",
                { staticClass: "info__con", staticStyle: { color: "#ff0000" } },
                [_vm._v(_vm._s(_vm.info.not_activated_number))]
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("已激活："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(" " + _vm._s(_vm.info.activated_number) + " "),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("已作废："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.delete_number)),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("审核中："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.review_number)),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("已冻结："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(" " + _vm._s(_vm.info.frozen_number) + " "),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }, [
              _c("span", { staticClass: "title--word-style" }, [
                _vm._v("清余额："),
              ]),
              _c("span", { staticClass: "info__con" }, [
                _vm._v(_vm._s(_vm.info.clear_balance_number)),
              ]),
            ]),
            _c("div", { staticClass: "from__style-item style-width" }),
          ]),
        ],
        1
      ),
      _vm.$hasBtnRoles("/orders/card-management/exception-card") &&
      (_vm.info.exception_status == 1 || _vm.info.exception_status == 0)
        ? _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                effect: "dark",
                content:
                  "仅处理【待售】卡，【未激活】卡请在订单详情中进行售卡或退卡操作！",
                placement: "top-start",
              },
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleDialog } },
                [
                  _vm._v("待售卡处理"),
                  _c("i", {
                    staticClass: "el-icon-warning-outline el-icon--right",
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-card",
        {
          staticClass: "box-card rule",
          staticStyle: { "margin-bottom": "10px" },
          attrs: { shadow: "never" },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", { staticClass: "title" }, [_vm._v("处理操作记录")]),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                "header-cell-style": {
                  background: "#F1F1F1",
                  color: "#333333",
                },
                data: _vm.logs,
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "卡信息", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(" " + _vm._s(scope.row.card_type_name) + " "),
                        ]),
                        _c("div", [
                          _vm._v(
                            "物料类型： " + _vm._s(scope.row.material_type_cn)
                          ),
                        ]),
                        _c("div", [
                          _vm._v("起：" + _vm._s(scope.row.begin_code)),
                        ]),
                        _c("div", [
                          _vm._v("止：" + _vm._s(scope.row.end_code)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "exception_reason_cn", label: "异常原因" },
              }),
              _c("el-table-column", {
                attrs: { prop: "exception_method_cn", label: "处理方式" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.exception_method != 3
                          ? _c("span", [
                              _vm._v(_vm._s(scope.row.exception_method_cn)),
                            ])
                          : _vm._e(),
                        scope.row.exception_method == 3
                          ? _c("div", [
                              _c("div", { staticClass: "img-dialog" }, [
                                _vm._v(_vm._s(scope.row.exception_method_cn)),
                              ]),
                              _c(
                                "div",
                                [
                                  _c("el-image", {
                                    attrs: {
                                      "preview-src-list": scope.row.file,
                                      width: "100%",
                                      src: scope.row.file[0],
                                      alt: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        scope.row.material_name
                          ? _c("div", [
                              _vm._v(
                                "退回物料：" + _vm._s(scope.row.material_name)
                              ),
                            ])
                          : _vm._e(),
                        scope.row.branch_office_name
                          ? _c("div", [
                              _vm._v(
                                "退回仓库：" +
                                  _vm._s(scope.row.branch_office_name)
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "action_cn", label: "操作类型" },
              }),
              _c("el-table-column", {
                attrs: { prop: "add_user_name", label: "操作人-时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.add_user_name))]),
                        _c("div", [_vm._v(_vm._s(scope.row.created_time))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", { attrs: { prop: "note", label: "备注" } }),
              _c("el-table-column", {
                attrs: { prop: "", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.$hasBtnRoles("/orders/card-management/rollback") &&
                        (scope.row.exception_method == 2 ||
                          scope.row.exception_method == 3 ||
                          scope.row.exception_method == 4) &&
                        scope.row.rollback_status == 0
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.rollback(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 作废回退")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleClose },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "待售卡超期处理",
            visible: _vm.showDialog,
            width: "40%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDialog = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "exceptionCardForm",
              attrs: { model: _vm.exceptionCardForm, "label-width": "100Px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "序列号段：", required: "" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { indeterminate: _vm.isIndeterminate },
                      on: { change: _vm.handleCheckAllChange },
                      model: {
                        value: _vm.checkAll,
                        callback: function ($$v) {
                          _vm.checkAll = $$v
                        },
                        expression: "checkAll",
                      },
                    },
                    [_vm._v("选中全部")]
                  ),
                ],
                1
              ),
              _c(
                "el-checkbox-group",
                {
                  attrs: { size: "medium" },
                  on: { change: _vm.handleCheckedCitiesChange },
                  model: {
                    value: _vm.checkList,
                    callback: function ($$v) {
                      _vm.checkList = $$v
                    },
                    expression: "checkList",
                  },
                },
                _vm._l(
                  _vm.exceptionCardForm.card_numbers,
                  function (item, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "", required: "" } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { flex: "0 0 37.5%" },
                                    attrs: {
                                      prop:
                                        "card_numbers." + index + ".begin_code",
                                      rules: [
                                        {
                                          required: true,
                                          trigger: "blur",
                                          message: "请填写开始卡序号",
                                        },
                                        {
                                          pattern: /^([0-9]*)$/,
                                          message: "请填写，仅限正整数",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input__width-code",
                                      attrs: {
                                        maxlength: "16",
                                        "show-word-limit": "",
                                        placeholder: "起始序列号",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.codeBlur($event, item, 2)
                                        },
                                      },
                                      model: {
                                        value: item.begin_code,
                                        callback: function ($$v) {
                                          _vm.$set(item, "begin_code", $$v)
                                        },
                                        expression: "item.begin_code",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { margin: "0 10px" } },
                                  [_vm._v("-")]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { flex: "0 0 37.5%" },
                                    attrs: {
                                      prop:
                                        "card_numbers." + index + ".end_code",
                                      rules: [
                                        {
                                          required: true,
                                          trigger: "blur",
                                          message: "请填写结束卡序号",
                                        },
                                        {
                                          pattern: /^([0-9]*)$/,
                                          message: "请填写，仅限正整数",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input__width-code",
                                      staticStyle: { flex: "1" },
                                      attrs: {
                                        maxlength: "16",
                                        "show-word-limit": "",
                                        placeholder: "结束序列号",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.codeBlur($event, item, 2)
                                        },
                                      },
                                      model: {
                                        value: item.end_code,
                                        callback: function ($$v) {
                                          _vm.$set(item, "end_code", $$v)
                                        },
                                        expression: "item.end_code",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-checkbox",
                                  {
                                    staticStyle: { "margin-left": "20px" },
                                    attrs: { label: index },
                                  },
                                  [_c("div")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
              _c(
                "el-form-item",
                { attrs: { label: "卡数量" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "80%" },
                    attrs: {
                      disabled: "",
                      value: _vm.numbers,
                      placeholder: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "异常原因", prop: "exception_reason" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.exceptionCardForm.exception_reason,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.exceptionCardForm,
                            "exception_reason",
                            $$v
                          )
                        },
                        expression: "exceptionCardForm.exception_reason",
                      },
                    },
                    _vm._l(_vm.exception_reason, function (item, index) {
                      return _c(
                        "el-radio",
                        { key: index, attrs: { label: index + 1 } },
                        [_vm._v(_vm._s(item))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "处理方式", prop: "exception_method" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.exceptionCardForm.exception_method,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.exceptionCardForm,
                            "exception_method",
                            $$v
                          )
                        },
                        expression: "exceptionCardForm.exception_method",
                      },
                    },
                    _vm._l(_vm.exception_method, function (item, index) {
                      return _c(
                        "el-radio",
                        {
                          key: index,
                          staticStyle: {
                            width: "30%",
                            "margin-bottom": "10px",
                          },
                          attrs: { label: index + 1 },
                        },
                        [_vm._v(_vm._s(item))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.exceptionCardForm.exception_method == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "退回物料", prop: "material_name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "80%" },
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.exceptionCardInfo.material_name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.exceptionCardInfo,
                              "material_name",
                              $$v
                            )
                          },
                          expression: "exceptionCardInfo.material_name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.exceptionCardForm.exception_method == 1
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "退回仓库", prop: "branch_office_name" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "80%" },
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.exceptionCardInfo.branch_office_name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.exceptionCardInfo,
                              "branch_office_name",
                              $$v
                            )
                          },
                          expression: "exceptionCardInfo.branch_office_name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.exceptionCardForm.exception_method == 3
                ? _c(
                    "el-form-item",
                    [
                      _c("upload-file", {
                        ref: "uploadBanner",
                        attrs: {
                          limit: 10,
                          "link-url": _vm.linkUrl,
                          tempurl: _vm.exceptionCardForm.file,
                        },
                        on: {
                          delImgIndex: _vm.delImgIndex,
                          emitUploadFile: function (res) {
                            return _vm.emitUploadFile(res)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "note" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "80%" },
                    attrs: { type: "textarea", placeholder: "请输入", rows: 5 },
                    model: {
                      value: _vm.exceptionCardForm.note,
                      callback: function ($$v) {
                        _vm.$set(_vm.exceptionCardForm, "note", $$v)
                      },
                      expression: "exceptionCardForm.note",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }